import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden py-20 px-4" data-id="element-38">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-39">
        <div className="absolute inset-0 bg-gradient-to-b from-[#1a1714]/80 via-[#1a1714]/60 to-[#1a1714] z-10" data-id="element-40" />
        <img src="https://cdn.magicpatterns.com/uploads/rPMNttxUCfMBaUDby5eRFk/heylloyd-image-1770714308623.png" alt="Mujer leyendo en tablet con luz de lámpara" className="w-full h-full object-cover opacity-60" data-id="element-41" />
      </div>

      {/* Content */}
      <div className="relative z-20 max-w-4xl mx-auto text-center" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.2,
        ease: 'easeOut'
      }} data-id="element-43">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif text-[#f5efe6] leading-tight mb-6 tracking-tight" data-id="element-44">
            Que la noche no te <br className="hidden md:block" data-id="element-45" />
            encuentre sin plan.
          </h1>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.2,
        delay: 0.4,
        ease: 'easeOut'
      }} className="text-xl md:text-2xl text-[#d4a574] font-light mb-12 max-w-2xl mx-auto" data-id="element-46">
          10 noches. 20 minutos. Y el silencio pesa menos.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.2,
        delay: 0.8,
        ease: 'easeOut'
      }} data-id="element-47">
          <button onClick={() => document.getElementById('cta-protocolo')?.scrollIntoView({
          behavior: 'smooth'
        })} className="group inline-flex items-center gap-2 px-8 py-4 bg-[#d4a574]/10 hover:bg-[#d4a574]/20 border border-[#d4a574]/30 text-[#d4a574] rounded-full transition-all duration-500 backdrop-blur-sm" data-id="element-48">
            <span className="text-lg tracking-wide" data-id="element-49">Descubre el Protocolo</span>
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" data-id="element-50" />
          </button>
        </motion.div>
      </div>
    </section>;
}